import { provideChameleonDesignSystem } from '../../provideChameleonDesignSystem';
import { chameleonDataTablePaginationV2 } from './definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDataTablePaginationV2({ prefix }));
}
